import styled from 'styled-components';
import { DeprecatedGrid as Grid } from '@simplywallst/ui-core';

export const WatchlistButtonWrapper = styled(Grid)`
  margin-top: ${({ theme }) => theme.x2spacePx}px;

  svg {
    margin: -3px 0 0 0;
  }
`;
